export default function (data) {
  return {
    chart: {
      renderTo: 'container',
      type: 'column',
      backgroundColor: 'rgba(0,0,0,0)',
      options3d: {
        enabled: true,
        alpha: 15,
        beta: 15,
        depth: 50,
        viewDistance: 25
      }
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    xAxis: {
      categories: data.dataList.map(item => item.dataSubCodeName),
      title: {
        text: null
      },
      labels: {
        style: {
          color: '#ffffff'
        }
      }
    },
    yAxis: {
      title: {
        text: '百分比',
        style: {
          color: '#ffffff'
        }
      },
      labels: {
        style: {
          color: '#ffffff'
        }
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        depth: 25
      }
    },
    tooltip: {
      valueSuffix: ''
    },
    series: [
      {
        name: '百分比',
        data: data.dataList.map(item => item.percentage)
      }
    ],
    credits: {
      enabled: false
    }
  }
}
